import { Model } from 'core/models';


export class FileTemplateInput extends Model {
    public id?: number;
    public fieldName?: string;
    public fieldValue?: string;
    public order?: number;
}
